<h3>Unprocessed</h3>

<div class="container">

  <div class="upload">
    <input #fileInput style="display: none;" type="file" (change)="onFileSelected($event)" />
    <button (click)="fileInput.click()">Upload Image</button>
  </div>
  <div class="item-list">
    <div *ngIf="unprocessedImages.length < 1">Empty</div>
    <div *ngFor="let image of unprocessedImages" class="item">
      <span>{{ image.state }}</span>
      <img [alt]="image.id" [src]="image.path" />
      <button (click)="process(image.id)">Process</button>
    </div>
  </div>
</div>